const IMG_1 =
  "https://images.unsplash.com/photo-1615876063860-d971f6dca5dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxiaW9waGlsaWMlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzkwOTUxNzN8MA&ixlib=rb-4.1.0&q=85";
const IMG_2 =
  "https://images.unsplash.com/photo-1634822929331-ee4dc2c97fc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxiaW9waGlsaWMlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzkwOTUxNzN8MA&ixlib=rb-4.1.0&q=85";

const STATS = [
  { value: "120+", label: "Spaces composed" },
  { value: "9", label: "Cities cared for" },
  { value: "100%", label: "Live plant maintenance" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#F9F8F6] py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left column — text */}
          <div className="lg:col-span-6 reveal">
            <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C6658] mb-6">
              04 / About Indoor Greens
            </p>
            <h2 className="font-[Outfit] font-extralight text-[#2D332B] text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.015em]">
              A studio devoted to the
              <span className="italic text-[#8A9A86]"> slow craft </span>
              of bringing rooms back to life.
            </h2>
            <div className="mt-10 space-y-6 text-[15px] sm:text-[17px] leading-[1.75] text-[#5C6658] max-w-xl">
              <p>
                We design biophilic environments for residences, boutique
                hotels, restaurants and considered workplaces — choosing each
                specimen for the room it will inhabit, the light it will
                drink, the people it will hold.
              </p>
              <p>
                Beyond installation, we remain. A small team of botanists and
                designers maintains every project, season after season, so
                that what we plant continues to deepen rather than fade.
              </p>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-6 border-t border-[#E5E1DB] pt-10">
              {STATS.map((s) => (
                <div key={s.label} data-testid={`stat-${s.label}`}>
                  <p className="font-[Outfit] text-3xl sm:text-4xl font-light text-[#2D332B]">
                    {s.value}
                  </p>
                  <p className="mt-2 text-[10px] sm:text-[11px] tracking-[0.25em] uppercase text-[#5C6658] leading-relaxed">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right column — bento images */}
          <div className="lg:col-span-6 reveal">
            <div className="grid grid-cols-6 grid-rows-6 gap-4 sm:gap-6 h-[520px] sm:h-[640px]">
              <div className="col-span-4 row-span-4 relative overflow-hidden rounded-sm">
                <img
                  src={IMG_1}
                  alt="Biophilic living space"
                  className="w-full h-full object-cover transition-transform duration-[1200ms] hover:scale-[1.04]"
                />
              </div>
              <div className="col-span-2 row-span-3 col-start-5 row-start-1 relative overflow-hidden rounded-sm bg-[#F2EFEB] p-6 flex flex-col justify-between border border-[#E5E1DB]">
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#5C6658]">
                  Practice
                </span>
                <p className="font-[Outfit] text-[22px] sm:text-[26px] font-light leading-[1.15] text-[#2D332B]">
                  Design.
                  <br />
                  Installation.
                  <br />
                  Ongoing care.
                </p>
              </div>
              <div className="col-span-2 row-span-3 col-start-5 row-start-4 relative overflow-hidden rounded-sm">
                <img
                  src={IMG_2}
                  alt="Plant detail"
                  className="w-full h-full object-cover transition-transform duration-[1200ms] hover:scale-[1.04]"
                />
              </div>
              <div className="col-span-4 row-span-2 row-start-5 relative overflow-hidden rounded-sm bg-[#2D332B] text-[#F9F8F6] p-6 flex items-end">
                <p className="font-[Outfit] text-[20px] sm:text-[24px] font-light leading-[1.2] italic">
                  &ldquo;Rooms that breathe with you.&rdquo;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
